// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__32olJ","list":"PatternAutocomplete_list__Qgpl1"};